export enum InputType {
  STRING = 'string',
  NUMBER = 'number',
  TIME = 'time'
}
